import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const SIZE = 6;
const FIRST_LEVEL_TIME = 120;

const makeNewBoard = () =>
  Array.from(Array(SIZE)).map(() => Array.from(Array(SIZE)).map(() => true));

const isInBoardBoundaries = ({ x, y }) =>
  y >= 0 && y < SIZE && x >= 0 && x < SIZE;

const performInlineSwitch = (board, { x, y }) => {
  if (isInBoardBoundaries({ x, y })) {
    board[y][x] = !board[y][x];
  }
};

const performInlineMove = (board, { x, y }) => {
  performInlineSwitch(board, { x, y });

  performInlineSwitch(board, { x, y: y - 1 });
  performInlineSwitch(board, { x, y: y + 1 });
  performInlineSwitch(board, { x: x - 1, y });
  performInlineSwitch(board, { x: x + 1, y });
};

const copyBoard = board => board.map(row => row.map(cell => cell));

const state = {
  level: 0,
  board: makeNewBoard(),
  hint: null,
  levelTime: FIRST_LEVEL_TIME,
  elapsedTime: 0,
  gameOver: false
};

const getters = {
  board: state => state.board,
  hint: state => state.hint,
  level: state => state.level,
  isBoardFull: state => state.board.every(row => row.every(cell => cell)),
  remainingTimePercentage: state =>
    ((state.levelTime - state.elapsedTime) / state.levelTime) * 100,
  gameOver: state => state.gameOver
};

const mutations = {
  makeBoard(state, level) {
    const board = makeNewBoard();
    const numberOfInitialMoves = Math.pow(2, level);

    for (let i = 0; i < numberOfInitialMoves; i++) {
      const x = Math.floor(Math.random() * SIZE);
      const y = Math.floor(Math.random() * SIZE);

      performInlineMove(board, { x, y });
      if (level === 0) {
        state.hint = { x, y };
      }
    }

    state.board = board;
  },
  switchCell(state, { x, y }) {
    const board = copyBoard(state.board);

    performInlineMove(board, { x, y });

    state.board = board;
    state.hint = null;
  },
  increaseLevel(state) {
    state.level++;
    state.levelTime -= 2;
    state.elapsedTime = 0;
  },
  increaseElapsedTime(state) {
    state.elapsedTime += state.level;
    if (state.elapsedTime >= state.levelTime) {
      state.gameOver = true;
    }
  },
  setGameOver(state, value) {
    state.gameOver = value;
  },
  resetTimer(state) {
    state.levelTime = FIRST_LEVEL_TIME;
    state.elapsedTime = 0;
  },
  setLevel(state, value) {
    state.level = value;
  }
};

const actions = {
  makeInitialMap({ commit }) {
    commit("setLevel", 0);
    commit("makeBoard", 0);
    commit("setGameOver", false);
    commit("resetTimer");
  },
  switchCell({ commit, getters }, { x, y }) {
    commit("switchCell", { x, y });
    if (getters.isBoardFull) {
      commit("increaseLevel");
      commit("makeBoard", getters.level);
    }
  },
  increaseElapsedTime({ commit, getters }) {
    if (!getters.gameOver) {
      commit("increaseElapsedTime");
    }
  }
};

export default new Vuex.Store({
  state,
  getters,
  mutations,
  actions
});
